import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { MaintenanceDialogService } from '../../../service/shared/maintenance-dialog.service';

@Component({
  selector: 'app-maintenance-dialog',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule],
  templateUrl: './maintenance-dialog.component.html',
  styleUrls: ['./maintenance-dialog.component.scss']
})

export class MaintenanceDialogComponent {
  dateTimeText:string = null;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data:any,
    private dialogRef: MatDialogRef<MaintenanceDialogComponent>,
    private maintenanceDialogService: MaintenanceDialogService
  ) {}

  ngOnInit(){
    this.dateTimeText = this.maintenanceDialogService.getStartDateTimeToEndDateTimeText()
  }

  closeDialog(){
    this.dialogRef.close();
    sessionStorage.setItem('scheduleOutageDialogHiddenByAdmin', 'Y');
  }
}